import { TRACK_ORIGIN } from 'stash/actions/tracking';

const productEventsReducer = (state = {}, action) => {
	switch (action.type) {
		case TRACK_ORIGIN: {
			return {
				...state,
				productEventsOrigin: action.origin,
			};
		}

		default:
			return state;
	}
};

export default productEventsReducer;
